var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCells(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 490 490",
    style: {
      enableBackground: "new 0 0 490 490"
    },
    xmlSpace: "preserve",
    height: "1em",
    width: "1em",
    fill: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M489,307.68c0-7.1-4.1-13.3-10.2-17.4l-90.9-52.1c-6.1-4.1-14.3-4.1-20.4,0l-89.8,53.1c-6.1,3.1-10.2,10.2-10.2,17.4 l1,104.1c0,7.1,4.1,13.3,10.2,17.4l90.9,52.1c6.6,3.9,13.4,4.4,20.4,0l89.8-53.1c6.1-3.1,10.2-10.2,10.2-17.4L489,307.68z  M378.7,441.38l-70.4-39.8l-1-80.6l69.4-40.8l70.4,39.8l1,80.6L378.7,441.38z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.3,290.28l-90.9-52.1c-6.1-4.1-14.3-4.1-20.4,0l-89.8,53.1c-6.1,3.1-10.2,10.2-10.2,17.4l1,104.1 c0,7.1,4.1,13.3,10.2,17.4l90.9,52.1c6.6,3.9,13.4,4.4,20.4,0l89.8-53.1c6.1-3.1,10.2-10.2,10.2-17.4l-1-104.1 C221.5,300.48,217.4,294.38,211.3,290.28z M111.3,441.38l-70.4-39.8l-1-80.6l69.4-40.8l70.4,39.8l1,80.6L111.3,441.38z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.3,181.28l-1-104.1c0-7.1-4.1-13.3-10.2-17.4l-90.9-52.1c-6.1-4.1-14.3-4.1-20.4,0L144,60.78 c-6.1,3.1-10.2,10.2-10.2,17.4l1,104.1c0,7.1,4.1,13.3,10.2,17.4l90.9,52.1c6.6,3.9,13.4,4.4,20.4,0l89.8-53.1 C352.2,195.58,356.3,188.48,356.3,181.28z M245,210.88l-70.4-39.8l-1-80.6l69.4-40.9l70.4,39.8l1,80.6L245,210.88z"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCells);
export default __webpack_public_path__ + "static/media/cells.84c3860b.svg";
export { ForwardRef as ReactComponent };